import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteTyreBrandDiscountMutation } from "modules/TyreDiscountsDashboard/components/DeleteTyreBrandDiscountModal/hooks";

import type { TyreDiscount } from "models";

type DeleteTyreBrandDiscountModalProps = {
  tyreDiscountId: number;
  tyreBrandDiscountId: number;
  discounts?: TyreDiscount[];
  onResetDeleteTyreBrandDiscountId: () => void;
  onCollapseRow: (rowId: string) => void;
};

export const DeleteTyreBrandDiscountModal = ({
  discounts = [],
  tyreDiscountId,
  tyreBrandDiscountId,
  onCollapseRow,
  onResetDeleteTyreBrandDiscountId
}: DeleteTyreBrandDiscountModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteTyreBrandDiscount, isPending } = useDeleteTyreBrandDiscountMutation();

  const handleDeleteTyreDiscount = async () => {
    if (!tyreBrandDiscountId || !tyreDiscountId) return;
    await deleteTyreBrandDiscount({ tyre_brand_discount_id: tyreBrandDiscountId, tyre_discount_id: tyreDiscountId });

    const rowIdx = discounts.findIndex(element => element.id === tyreDiscountId);
    if (rowIdx > -1 && discounts[rowIdx].tyre_brand_discounts?.length === 1) onCollapseRow(String(rowIdx));
    onResetDeleteTyreBrandDiscountId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={Boolean(tyreBrandDiscountId && tyreDiscountId)}
      isLoading={isPending}
      handleCancel={onResetDeleteTyreBrandDiscountId}
      handleConfirm={handleDeleteTyreDiscount}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
    />
  );
};
